import backendVersion from '../rw-app-version/reducers/backend-app-version';

export default backendVersion;



// WEBPACK FOOTER //
// ./src/modules/utils/reducers/backend-version.reducer.js